/**
Coded by www.techhighway.ca

*/

import { forwardRef } from "react";

// prop-types is a library for typechecking of props

// Custom styles for MDButton
import MDCircularProgressRoot from "components/MDCircularProgress/MDCircularProgressRoot";

// Material Dashboard 2 React contexts
import { useMaterialUIController } from "context";

const MDCircularProgress = forwardRef(({ color, ...rest }, ref) => {
  const [controller] = useMaterialUIController();

  return <MDCircularProgressRoot color={color || "light"} {...rest} />;
});

// Setting default values for the props of MDButton
MDCircularProgress.defaultProps = {};

export default MDCircularProgress;
